var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPauseCtaOutline = function SvgPauseCtaOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.158 2.365v19.27c0 1.025.766 1.865 1.7 1.865h2.733c.936 0 1.7-.84 1.7-1.866V2.365C9.292 1.34 8.528.5 7.592.5H4.86c-.935 0-1.7.84-1.7 1.865Zm1.7 19.697c-.11 0-.262-.167-.262-.428V2.365c0-.26.153-.428.263-.428H7.59c.11 0 .263.168.263.428v19.27c0 .26-.153.427-.263.427H4.86ZM16.409.5h2.733c.935 0 1.7.84 1.7 1.866v19.269c0 1.025-.765 1.865-1.7 1.865h-2.733c-.934 0-1.7-.84-1.7-1.865V2.365c0-1.025.766-1.865 1.7-1.865Zm-.263 1.866c0-.26.154-.428.263-.428h2.733c.11 0 .263.167.263.428v19.269c0 .26-.153.427-.263.427h-2.733c-.11 0-.263-.167-.263-.427V2.365Z",
    fill: "currentColor"
  })));
};
export default SvgPauseCtaOutline;